// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.services-container {
  padding: 20px;
  max-width: 1600px;
  background-color: #ddd;
}

.services-header {
  text-align: left;
  margin-bottom: 20px;
  font-size: 2rem;
  font-weight: bold;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 20fr));
  gap: 20px;
}

.service-card {
  width: 100%;
  height: 100%;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
}

.sticky-card .service-image-container {
  position: relative;
}

.sticky-card .sticky-image {
  position: sticky;
  top: 200px;
  width: 100%;
  height: auto;
  margin-top: -200%;
  margin-bottom: -19%;
}
.it-image {
  position: sticky;
}
.moving-images {
  position: absolute;
  bottom: 29% !important;
  right: -8%;

  transform: translateX(-50%);
  width: 350%;
  display: flex;
  justify-content: center;
  pointer-events: none;
  transition: transform 0s ease-in-out;
  animation: moveImages 10s linear infinite;
  gap: 35%;
  flex-shrink: 0;
}

.moving-image {
  width: 120px;
  height: auto;
  gap: 25%;
}
.moving-image.active {
  left: 0;
  opacity: 10;
  z-index: 10;
}

.moving-image.inactive {
  left: -100%;
  opacity: 0;
  z-index: 0;
}

.it-image {
  width: 120px;
  height: 120px;
  border: 2px solid #ddd;
  margin-top: -80px;
}

.engineering-image {
  width: 140px;
  height: auto;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.other-image {
  width: 130px;
  height: 130px;
  border: 2px solid #ccc;
}

@keyframes moveImages {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
@keyframes slide-in {
  0% {
    transform: translateX(-100%);
    opacity: 0;
  }
  100% {
    transform: translateX();
    opacity: 1;
  }
}

.service-divider {
  margin-bottom: 15px;
  border-top: 1px solid #ddd;
}

.service-button {
  margin-bottom: 8px;
  padding: 10px 10px;
  margin-left: 60%;
  background-color: rgb(255, 255, 255);
  color: #15801e;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
  font-size: 100%;
  align-self: flex-start;
}

.service-button:hover {
  background-color: #6adb73;
  color: white;
  transition: 0.3s;
}

.service-detail {
  text-align: center;
  padding: 20px;
}

.service-detail-image {
  width: 100%;
  height: auto;
  max-width: 400px;
  margin: 0 auto;
  display: block;
}

.service-detail-title {
  font-size: 2rem;
  margin-top: 20px;
}

.service-detail-description {
  font-size: 1.1rem;
  margin-top: 10px;
  color: #555;
}

.back-button {
  background-color: #007bff;
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  margin-bottom: 20px;
  transition: background-color 0.3s;
}

.back-button:hover {
  background-color: #0056b3;
}
.service-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}
.service-image-container {
  position: relative;
  width: 100%;
  height: 90%;
  overflow: hidden;
}
.service-card:hover .service-image {
  transform: scale(1.1) translateY(-10px);
}
.service-card-content {
  padding: 20px;
  flex: 1 1;
  transition: transform 0.5s ease-in-out;
}
@media (max-width: 768px) {
  .services-grid {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  .service-card {
    border-radius: 4px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  }

  .service-image {
    width: 100%;
    height: auto;
    object-fit: cover;
    transition: transform 0.3s ease;
  }

  .service-button {
    font-size: 12px;
    padding: 8px 16px;
    margin-left: 0;
    align-self: center;
  }
}

@media (min-width: 1366px) and (min-height: 768px) {
  .services-grid {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 25px;
  }

  .service-card {
    border-radius: 10px;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
    padding: 20px;
  }

  .services-header {
    font-size: 2.5rem;
  }

  .service-button {
    font-size: 16px;
    padding: 12px 20px;
    margin-left: auto;
  }

  .service-detail {
    max-width: 800px;
    margin: 0 auto;
  }

  .service-detail-title {
    font-size: 2.5rem;
  }

  .service-detail-description {
    font-size: 1.3rem;
    line-height: 1.8;
  }

  .service-divider {
    border-top: 2px solid #ddd;
  }
}

@media (min-width: 1366px) {
  .moving-images {
    bottom: 25% !important;
    right: -5%;
    width: 300%;
    gap: 20%;
  }

  .sticky-card .sticky-image {
    height: 78vh !important;
  }
  .moving-image {
    width: 100px;
    height: auto;
    margin-bottom: -4%;
  }

  .it-image {
    width: 140px;
    height: 140px;
    margin-top: -60px;
  }
}

@media (max-width: 1380px) and (min-width: 1024px) {
  .moving-images {
    bottom: 27%;
    right: -6%;
    width: 320%;
    gap: 22%;
  }

  .moving-image {
    width: 100px;
    height: auto;
  }

  .it-image {
    width: 130px;
    height: 130px;
    margin-top: -70px;
  }
}

@media (max-width: 1024px) and (min-width: 768px) {
  .moving-images {
    bottom: 18%;
    right: -7%;
    width: 280%;
    gap: 18%;
  }

  .moving-image {
    width: 90px;
    height: auto;
  }

  .it-image {
    width: 100px;
    height: 100px;
    margin-top: -50px;
  }
}

@media (max-width: 768px) {
  .moving-images {
    bottom: 23% !important;
    right: -10%;
    width: 250%;
    gap: 15%;
  }

  .moving-image {
    width: 100px;
    height: auto;
    gap: 25%;
  }
  .it-image {
    width: 80px;
    height: 80px;
    margin-top: -40px;
  }
  .sticky-card .sticky-image {
    position: sticky;
    top: 200px;
    width: 100%;
    height: auto;
    margin-top: -2%;
    margin-bottom: 6px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Services/Services.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;;EAEV,2BAA2B;EAC3B,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,oCAAoC;EACpC,yCAAyC;EACzC,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,QAAQ;AACV;AACA;EACE,OAAO;EACP,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,uBAAuB;IACvB,UAAU;EACZ;AACF;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,4BAA4B;EAC5B,yCAAyC;AAC3C;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,uCAAuC;AACzC;AACA;EACE,aAAa;EACb,SAAO;EACP,sCAAsC;AACxC;AACA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,yCAAyC;EAC3C;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,+BAA+B;EACjC;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,2DAA2D;IAC3D,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,yCAAyC;IACzC,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,UAAU;IACV,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,uBAAuB;EACzB;EACA;IACE,YAAY;IACZ,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,WAAW;IACX,UAAU;IACV,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,WAAW;IACX,UAAU;IACV,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,WAAW;IACX,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,QAAQ;EACV;EACA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;AACF","sourcesContent":[".services-container {\n  padding: 20px;\n  max-width: 1600px;\n  background-color: #ddd;\n}\n\n.services-header {\n  text-align: left;\n  margin-bottom: 20px;\n  font-size: 2rem;\n  font-weight: bold;\n}\n\n.services-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 20fr));\n  gap: 20px;\n}\n\n.service-card {\n  width: 100%;\n  height: 100%;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  position: relative;\n}\n\n.sticky-card .service-image-container {\n  position: relative;\n}\n\n.sticky-card .sticky-image {\n  position: sticky;\n  top: 200px;\n  width: 100%;\n  height: auto;\n  margin-top: -200%;\n  margin-bottom: -19%;\n}\n.it-image {\n  position: sticky;\n}\n.moving-images {\n  position: absolute;\n  bottom: 29% !important;\n  right: -8%;\n\n  transform: translateX(-50%);\n  width: 350%;\n  display: flex;\n  justify-content: center;\n  pointer-events: none;\n  transition: transform 0s ease-in-out;\n  animation: moveImages 10s linear infinite;\n  gap: 35%;\n  flex-shrink: 0;\n}\n\n.moving-image {\n  width: 120px;\n  height: auto;\n  gap: 25%;\n}\n.moving-image.active {\n  left: 0;\n  opacity: 10;\n  z-index: 10;\n}\n\n.moving-image.inactive {\n  left: -100%;\n  opacity: 0;\n  z-index: 0;\n}\n\n.it-image {\n  width: 120px;\n  height: 120px;\n  border: 2px solid #ddd;\n  margin-top: -80px;\n}\n\n.engineering-image {\n  width: 140px;\n  height: auto;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.other-image {\n  width: 130px;\n  height: 130px;\n  border: 2px solid #ccc;\n}\n\n@keyframes moveImages {\n  0% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(100%);\n  }\n}\n@keyframes slide-in {\n  0% {\n    transform: translateX(-100%);\n    opacity: 0;\n  }\n  100% {\n    transform: translateX();\n    opacity: 1;\n  }\n}\n\n.service-divider {\n  margin-bottom: 15px;\n  border-top: 1px solid #ddd;\n}\n\n.service-button {\n  margin-bottom: 8px;\n  padding: 10px 10px;\n  margin-left: 60%;\n  background-color: rgb(255, 255, 255);\n  color: #15801e;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 100%;\n  align-self: flex-start;\n}\n\n.service-button:hover {\n  background-color: #6adb73;\n  color: white;\n  transition: 0.3s;\n}\n\n.service-detail {\n  text-align: center;\n  padding: 20px;\n}\n\n.service-detail-image {\n  width: 100%;\n  height: auto;\n  max-width: 400px;\n  margin: 0 auto;\n  display: block;\n}\n\n.service-detail-title {\n  font-size: 2rem;\n  margin-top: 20px;\n}\n\n.service-detail-description {\n  font-size: 1.1rem;\n  margin-top: 10px;\n  color: #555;\n}\n\n.back-button {\n  background-color: #007bff;\n  color: #fff;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n  margin-bottom: 20px;\n  transition: background-color 0.3s;\n}\n\n.back-button:hover {\n  background-color: #0056b3;\n}\n.service-card:hover {\n  transform: translateY(-10px);\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);\n}\n.service-image-container {\n  position: relative;\n  width: 100%;\n  height: 90%;\n  overflow: hidden;\n}\n.service-card:hover .service-image {\n  transform: scale(1.1) translateY(-10px);\n}\n.service-card-content {\n  padding: 20px;\n  flex: 1;\n  transition: transform 0.5s ease-in-out;\n}\n@media (max-width: 768px) {\n  .services-grid {\n    grid-template-columns: 1fr;\n    gap: 15px;\n  }\n\n  .service-card {\n    border-radius: 4px;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n  }\n\n  .service-image {\n    width: 100%;\n    height: auto;\n    object-fit: cover;\n    transition: transform 0.3s ease;\n  }\n\n  .service-button {\n    font-size: 12px;\n    padding: 8px 16px;\n    margin-left: 0;\n    align-self: center;\n  }\n}\n\n@media (min-width: 1366px) and (min-height: 768px) {\n  .services-grid {\n    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n    gap: 25px;\n  }\n\n  .service-card {\n    border-radius: 10px;\n    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);\n    padding: 20px;\n  }\n\n  .services-header {\n    font-size: 2.5rem;\n  }\n\n  .service-button {\n    font-size: 16px;\n    padding: 12px 20px;\n    margin-left: auto;\n  }\n\n  .service-detail {\n    max-width: 800px;\n    margin: 0 auto;\n  }\n\n  .service-detail-title {\n    font-size: 2.5rem;\n  }\n\n  .service-detail-description {\n    font-size: 1.3rem;\n    line-height: 1.8;\n  }\n\n  .service-divider {\n    border-top: 2px solid #ddd;\n  }\n}\n\n@media (min-width: 1366px) {\n  .moving-images {\n    bottom: 25% !important;\n    right: -5%;\n    width: 300%;\n    gap: 20%;\n  }\n\n  .sticky-card .sticky-image {\n    height: 78vh !important;\n  }\n  .moving-image {\n    width: 100px;\n    height: auto;\n    margin-bottom: -4%;\n  }\n\n  .it-image {\n    width: 140px;\n    height: 140px;\n    margin-top: -60px;\n  }\n}\n\n@media (max-width: 1380px) and (min-width: 1024px) {\n  .moving-images {\n    bottom: 27%;\n    right: -6%;\n    width: 320%;\n    gap: 22%;\n  }\n\n  .moving-image {\n    width: 100px;\n    height: auto;\n  }\n\n  .it-image {\n    width: 130px;\n    height: 130px;\n    margin-top: -70px;\n  }\n}\n\n@media (max-width: 1024px) and (min-width: 768px) {\n  .moving-images {\n    bottom: 18%;\n    right: -7%;\n    width: 280%;\n    gap: 18%;\n  }\n\n  .moving-image {\n    width: 90px;\n    height: auto;\n  }\n\n  .it-image {\n    width: 100px;\n    height: 100px;\n    margin-top: -50px;\n  }\n}\n\n@media (max-width: 768px) {\n  .moving-images {\n    bottom: 23% !important;\n    right: -10%;\n    width: 250%;\n    gap: 15%;\n  }\n\n  .moving-image {\n    width: 100px;\n    height: auto;\n    gap: 25%;\n  }\n  .it-image {\n    width: 80px;\n    height: 80px;\n    margin-top: -40px;\n  }\n  .sticky-card .sticky-image {\n    position: sticky;\n    top: 200px;\n    width: 100%;\n    height: auto;\n    margin-top: -2%;\n    margin-bottom: 6px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
